import { formMixin } from '@/mixins/form';
import { methodsMixin } from './methods';
import { minimalModalNoSchemaMixin } from './minimalModalNoSchema';

export function minimalModalMixin(emptyModel) {
  return {
    mixins: [formMixin, minimalModalNoSchemaMixin, methodsMixin],
    data() {
      return {
        model: emptyModel()
      };
    },
    methods: {
      // @vuese
      // Resetuje pola
      resetData() {
        this.$schema.$setData(emptyModel());
        this.$schema.$reset();
      }
    },

    watch: {
      /**
       * Resetuje pola modala przed pokazaniem go
       *
       * @param {boolean} val
       */
      show(val) {
        if (val) {
          this.resetData();
        }
      }
    }
  };
}
